<div
  class="cbp-entry-numbers-dialog"
  role="dialog"
  [attr.aria-label]="messages.usCbpEntryNumbersLabel">
  <div class="cbp-entry-numbers-header">
    <div class="ibc-body-text-large-bold">
      {{ messages.usCbpEntryNumbersLabel }}
    </div>
    <app-svg-icon
      [iconName]="'close'"
      class="cursor"
      [isStaticSvg]="true"
      [isFrom]="'Popup'"
      (staticIconClicked)="onClose()"></app-svg-icon>
  </div>

  <div class="cbp-entry-numbers-content">
    <mat-form-field
      appearance="outline"
      class="mat-md cbp-entry-numbers-search">
      <mat-label>{{ messages.usCbpEntryNumbersSearchPlaceholder }}</mat-label>
      <input
        matInput
        type="text"
        autocomplete="off"
        [formControl]="searchControl"
        [attr.aria-label]="messages.usCbpEntryNumbersSearchPlaceholder" />
      @if (hasSearchTerm) {
        <button
          matSuffix
          type="button"
          class="cbp-search-clear cursor"
          aria-label="Clear search"
          (click)="clearSearch()">
          <app-svg-icon
            [iconName]="icons.close"
            class="dropdown-close-icon"
            [isStaticSvg]="true"></app-svg-icon>
        </button>
      }
    </mat-form-field>

    <div class="cbp-entry-numbers-grid ibc-border-table">
      <mat-table [dataSource]="dataSource" matSort matSortDisableClear>
        @for (column of columns; track column.key) {
          <ng-container [matColumnDef]="column.key">
            <mat-header-cell *matHeaderCellDef>
              <span class="column-header cursor">
                <span class="ibc-body-text-large">{{ column.label }}</span>
                @if (dataSource.filteredData.length) {
                  <span [mat-sort-header]="column.key">
                    <app-svg-icon
                      [iconName]="'sort'"
                      [isStaticSvg]="true"
                      [isFrom]="'Page'"
                      [condition]="getSortCondition(column.key)"></app-svg-icon>
                  </span>
                }
              </span>
            </mat-header-cell>
            <mat-cell *matCellDef="let row">
              <span class="ibc-body-text-medium">
                {{ getCellValue(row, column.key) }}
              </span>
            </mat-cell>
          </ng-container>
        }

        <mat-header-row
          *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>

      @if (!isLoading && !dataSource.filteredData.length) {
        <div class="cbp-entry-numbers-empty ibc-body-text-medium">
          {{ emptyMessage }}
        </div>
      }
    </div>
  </div>

  <div class="cbp-entry-numbers-footer">
    <button
      type="button"
      class="ibc-medium-button ibc-secondary-default-button cursor"
      (click)="onClose()">
      <span class="ibc-body-text-regular">{{ popupButtons.Close }}</span>
    </button>
  </div>
</div>
